import styled from 'styled-components';

export const Template = styled.div`
  margin: 20px;
`
export const Title = styled.p`
  font-size: 19px;
  color: #000000;
  text-align: center;
`